import React, { useRef } from 'react';

const CLOUD_NAME = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME;
const UPLOAD_PRESET = process.env.REACT_APP_CLOUDINARY_PRESET;

export default function HorseMediaUpload({ onUploadComplete }) {
  const inputRef = useRef();

  const handleFile = async (file) => {
    if (!file) return;

    const isVideo = file.type.startsWith('video/');
    const endpoint = `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/${isVideo ? 'video' : 'image'}/upload`;

    const formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', UPLOAD_PRESET);

    console.log('🚀 Uploading to:', endpoint);
    console.log('🧾 Form Data:', { CLOUD_NAME, UPLOAD_PRESET, file });

    try {
      const res = await fetch(endpoint, {
        method: 'POST',
        body: formData,
      });

      const data = await res.json();
      console.log('📦 Cloudinary response:', data);

      if (!data.secure_url || !data.public_id) {
        throw new Error('Missing URL or public ID');
      }

      onUploadComplete({
        url: data.secure_url,
        public_id: data.public_id,
        type: isVideo ? 'video' : 'photo',
      });
    } catch (err) {
      console.error('❌ Upload failed:', err.message || err);
      alert('Upload failed. Please check your file and try again.');
    }
  };

  const handleChange = (e) => {
    const file = e.target.files[0];
    if (file) handleFile(file);
  };

  return (
    <div
      className="border-2 border-dashed border-gray-400 p-6 text-center rounded cursor-pointer"
      onClick={() => inputRef.current.click()}
    >
      <input
        type="file"
        accept="image/*,video/*"
        ref={inputRef}
        style={{ display: 'none' }}
        onChange={handleChange}
      />
      Click or Drag to Upload Horse Photo/Video
    </div>
  );
}